import { request } from "@/request/http";

export default {
  getQuestionBank: (data) => {
    return request("GET", `/index.php/backquestionbank/getQuestionBank`, data);
  },
  delQuestion: (data) => {
    return request("POST", `/index.php/backquestionbank/delQuestion`, data);
  },
};